var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "no-lab-banner-wr" },
    [
      _c("transition", { attrs: { name: "fade", appear: "" } }, [
        _c(
          "div",
          { staticClass: "no-lab-banner-wr__desktop" },
          [
            _c(
              _vm.tag,
              {
                tag: "component",
                staticClass: "no-lab-banner",
                class: {
                  "js-no-lab-banner": _vm.userAuthorized,
                  "no-lab-banner--lk": !_vm.isCatalog
                },
                attrs: {
                  "data-toggle": _vm.linkToModal.toggle,
                  "data-target": _vm.linkToModal.target,
                  href: _vm.href
                },
                on: { click: _vm.addLab }
              },
              [
                _c("h3", { staticClass: "no-lab-banner__title" }, [
                  _vm._v("Виртуальная кофе-лаборатория")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "no-lab-banner__content" }, [
                  _c("p", { staticClass: "no-lab-banner__content-title" }, [
                    _vm._v("Лаборатория позволит:")
                  ]),
                  _vm._v(" "),
                  _c("ul", [
                    _c("li", [
                      _vm._v("подобрать кофе, подходящий под ваше оборудование")
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v("получать рекомендации по улучшению оборудования")
                    ])
                  ]),
                  _vm._v(" "),
                  !_vm.isCatalog
                    ? _c("p", { staticClass: "no-lab-banner__offer" }, [
                        _vm._v("Заполните данные о вашем оборудование сейчас"),
                        _c("br"),
                        _vm._v(" и получите бонусы на оплату заказа.")
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "btn btn-main btn-sm btn-block no-lab-banner__action"
                  },
                  [_vm._v("Создать лабораторию")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "no-lab-banner__spots" },
                  _vm._l(4, function(item) {
                    return _c("span", {
                      key: item,
                      staticClass: "no-lab-banner__spot pulse-spot"
                    })
                  }),
                  0
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade", appear: "" } }, [
        _c("div", { staticClass: "no-lab-banner-wr__mobile" }, [
          _c(
            "div",
            {
              staticClass: "no-lab-banner",
              class: {
                "js-no-lab-banner-mobile": _vm.isCatalog,
                "no-lab-banner--open": !_vm.isCatalog
              }
            },
            [
              _c(
                "h3",
                {
                  staticClass: "no-lab-banner__title",
                  class: { "js-banner-title": _vm.isCatalog }
                },
                [
                  _c("span", [_vm._v("Виртуальная кофе-лаборатория")]),
                  _vm._v(" "),
                  _vm.isCatalog
                    ? _c("svg", [
                        _c("use", {
                          attrs: {
                            "xlink:href": "/sprite.svg#icon-chevron-collapse"
                          }
                        })
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "no-lab-banner__content" }, [
                _c("p", [_c("strong", [_vm._v("Лаборатория позволит:")])]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v("подобрать кофе, подходящий под ваше оборудование")
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v("получать рекомендации по улучшению оборудования")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                _vm.tag,
                {
                  tag: "component",
                  staticClass: "no-lab-banner__spots",
                  class: { "js-no-lab-banner": _vm.userAuthorized },
                  attrs: { href: _vm.href },
                  on: { click: _vm.addLab }
                },
                _vm._l(4, function(item) {
                  return _c("span", {
                    key: item,
                    staticClass: "no-lab-banner__spot pulse-spot"
                  })
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "no-lab-banner__action" },
                [
                  _c(
                    _vm.tag,
                    {
                      tag: "component",
                      staticClass: "btn btn-main btn-sm btn-block",
                      attrs: {
                        "data-toggle": _vm.linkToModal.toggle,
                        "data-target": _vm.linkToModal.target,
                        href: _vm.href
                      },
                      on: { click: _vm.addLab }
                    },
                    [
                      _vm._v(
                        "\n                        Создать лабораторию\n                    "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }